const ErrorInner = () => {
  return (
    <section className="features d-flex justify-content-center align-items-center text-center vh-100 position-relative overflow-hidden"
    style={{marginTop: '70px'}}>
      <div className="container">
        <div className="section-heading">
          <h1 className="mb-24 wow bounceIn" style={{ fontSize: "100px" }}>
            404
          </h1>
          <p className="wow bounceInUp">Sorry we can't find that page!</p>
          <div className="pt-40 border-top border-neutral-50 mt-40 border-dashed border-0">
            <a
              href="/"
              className="btn btn-main rounded-pill flex-align d-inline-flex gap-8"
            >
              Back To Home
              <i className="ph-bold ph-arrow-up-right d-flex text-lg" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ErrorInner;
